export default "__VITE_ASSET__X4fiLNu3__"